document.addEventListener("DOMContentLoaded", function () {
  // Filter按钮
  const filterButton = document.querySelector(
    ".mobile-facets__open.mobile-facets__open-v2.filter-button"
  );

  filterButton.addEventListener("click", function () {
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: "ga4Event",
      event_name: "select_content",
      event_parameters: {
        button_name: "Filter",
        content_type: "Collection",
      },
    });
  });

  // apply按钮
  const applyButton = document.querySelector(
    ".facets-container-v2 .mobile-facets__footer .apply-button"
  );
  applyButton.addEventListener("click", function () {
    // -----------------------------
    // 1. 从 URL 解析筛选条件
    // -----------------------------
    const params = new URLSearchParams(window.location.search);
    const conditions = [];

    // 1.1 Key Feature（多选）
    const keyFeatures = params.getAll("filter.p.m.custom.filter_key_feature");
    keyFeatures.forEach(function (v) {
      // 这里的 Key Feature=xxx 就是一个“条件”
      conditions.push(`${v}`);
    });

    // // 1.2 Scenario
    // const scenario = $(".collection-hero__title-text").text().trim();
    // if (scenario) {
    //   conditions.push(`${scenario}`);
    // }

    // 1.3 自由价格区间（From / To）
    const priceFrom = params.get("filter.v.price.gte");
    const priceTo = params.get("filter.v.price.lte");
    if (priceFrom || priceTo) {
      conditions.push(`${priceFrom || ""}~${priceTo || ""}`);
    }

    // -----------------------------
    // 2. 生成 $filterCombin
    //    条件1+条件2+条件3+... 的形式
    // -----------------------------
    const filterCombin = conditions.join(";");

    // -----------------------------
    // 3. 处理 $contentName 和 $buttonName
    // -----------------------------
    const contentName = "Collection Filters"; // 有真实内容标题就换掉
    const buttonName = "Apply Filters";

    // -----------------------------
    // 4. 推 GA4 埋点
    // -----------------------------
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });

    window.dataLayer.push({
      event: "ga4Event",
      event_name: "select_filters",
      event_parameters: {
        content_name: contentName || "", // 对应 $contentName
        filter_combin: filterCombin || "", // 对应 $filterCombin
        button_name: buttonName || "", // 对应 $buttonName
      },
    });
  });

  // clear all 按钮
  const clearButton = document.querySelector(
    ".facets-container-v2 .mobile-facets__footer .clear-button"
  );
  clearButton.addEventListener("click", function () {
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: "ga4Event",
      event_name: "select_content",
      event_parameters: {
        content_type: "Collection",
        content_name: "Collection Filter",
        button_name: "Clear All",
      },
    });
  });

  // 绑定在不会被替换的容器
  const facetsContainer = document.querySelector(".facets-container-v2");

  facetsContainer.addEventListener("click", function (e) {
    // PC：匹配 #sortBy li
    const pcItem = e.target.closest("#sortBy li");

    // Mobile：匹配 #sortByMobile li
    const mobileItem = e.target.closest("#sortByMobile li");

    // 都没有点击到时直接结束
    const item = pcItem || mobileItem;
    if (!item) return;

    const txt = item.textContent.trim();

    // GA4
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: "ga4Event",
      event_name: "select_content",
      event_parameters: {
        button_name: txt,
        content_type: "Collection",
        content_name: "collectionpage_sorting_tab",
      },
    });
  });


  //   曝光埋点
  var record_export_collection = new Set();
  var time_interval_home_product_list = -1;
  var home_product_list_attr = [];
  function home_product_ga4_deal_list(collection) {
    clearInterval(time_interval_home_product_list);
    let groupedItems = {}; // 用于存储按 item_list_id 分组的商品数组
    let collection_item = "";
    collection.forEach((element, index) => {
      collection_item = element.split("::");
      let $v_item_name = "";
      let $v_item_variant = "";
      let $v_item_category = "";
      let $v_item_category2 = "Standard";
      if (product_handle_map.has(collection_item[0])) {
        $v_item_name = product_handle_valueMap[collection_item[0]][0];
        $v_item_variant = product_handle_valueMap[collection_item[0]][1];
        $v_item_category = product_handle_valueMap[collection_item[0]][2];
        $v_item_category2 = product_handle_valueMap[collection_item[0]][3];
      }


      let arr_item = {
        item_id: collection_item[0],
        item_name: $v_item_name,
        index: index + 1,
        item_list_id: collection_item[3],
        item_list_name: collection_item[4],
        item_category: $v_item_category,
        item_category2: $v_item_category2,
        item_category3: collection_item[6].replace("Default Title", "none"),
        item_variant: $v_item_variant,
        item_brand: "SHOKZ",
        price: Number(
          collection_item[9].split("€").join("").split(",").join(".")
        ),
        quantity: Number(collection_item[10]),
        currency: "EUR",
      };
      // 根据 item_list_name 分组商品
      if (!groupedItems[collection_item[4].split(" ").join("")]) {
        groupedItems[collection_item[4].split(" ").join("")] = []; // 如果没有该组，初始化为空数组
      }
      groupedItems[collection_item[4].split(" ").join("")].push(arr_item); // 将当前商品添加到对应的组中
    });
    // console.log(final_arr);

    // 遍历分组并触发 dataLayer.push
    for (const itemListId in groupedItems) {
      if (groupedItems.hasOwnProperty(itemListId)) {
        window.dataLayer.push({ event_parameters: null });
        window.dataLayer.push({
          event: "ga4Event",
          event_name: "view_item_list",
          event_parameters: {
            currency: "EUR",
            item_list_id: groupedItems[itemListId][0]["item_list_name"],
            item_list_name: groupedItems[itemListId][0]["item_list_name"],
            items: groupedItems[itemListId], // 推送当前 item_list_name 对应的商品数组
          },
        });
      }
    }
  }

  // 创建一个 Intersection Observer 实例
  var observer_home_product = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // 在这里可以添加埋点逻辑
        let product_item = $(entry.target)
          .eq(0)
          .find(".product-data-div")
          .attr("data-product-data");
        let product_item2 = $(entry.target)
          .eq(0)
          .find(".product-data-div")
          .attr("data-product-data");
        // console.log('元素曝光:', product_item);

        product_item = product_item.split("::");
        let product_item_record = product_item[3] + product_item[8];
        product_item_record = product_item_record.split(" ").join("-");

        if (!record_export_collection.has(product_item_record)) {
          record_export_collection.add(product_item_record);
          // home_product_ga4_deal(product_item,"","view_item_list")
          home_product_list_attr.push(product_item2);
          clearInterval(time_interval_home_product_list);
          time_interval_home_product_list = setInterval(function () {
            clearInterval(time_interval_home_product_list);
            home_product_ga4_deal_list(home_product_list_attr);
            home_product_list_attr = [];
          }, 3000);
        }
        // 例如，发送曝光事件到服务器
        observer_home_product.unobserve(entry.target); // 可选：如果只需要一次曝光，可以取消观察
      }
    });
  });

  // 选择要观察的元素
  var targetElements_home_product = document.querySelectorAll(
    ".section-main-collection-v2 .product-grid-container .product-card-v2"
  );
  targetElements_home_product.forEach((element) => {
    observer_home_product.observe(element); // 开始观察每个元素
  });

  function page_product_ga4_deal(product_item, buttom_name, event_name) {
    let $v_item_name = "";
    let $v_item_variant = "";
    let $v_item_category = "";
    let $v_item_category2 = "Standard";
    if (product_handle_map.has(product_item[0])) {
      $v_item_name = product_handle_valueMap[product_item[0]][0];
      $v_item_variant = product_handle_valueMap[product_item[0]][1];
      $v_item_category = product_handle_valueMap[product_item[0]][2];
      $v_item_category2 = product_handle_valueMap[product_item[0]][3];
    }

    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: "ga4Event",
      event_name: event_name,
      event_parameters: {
        item_list_id: product_item[4],
        item_list_name: product_item[4],
        currency: "EUR",
        button_name: buttom_name,
        items: [
          {
            item_id: product_item[0],
            item_name: $v_item_name,
            index: Number(product_item[2]) + 1,
            item_list_id: product_item[3],
            item_list_name: product_item[4],
            item_category: $v_item_category,
            item_category2: $v_item_category2,
            item_category3: product_item[6].replace("Default Title", "none"),
            item_variant: $v_item_variant,
            item_brand: "SHOKZ",
            price: Number(
              product_item[9].split("€").join("").split(",").join(".")
            ),
            quantity: Number(product_item[10]),
            currency: "EUR",
          },
        ],
      },
    });
  }

  // 产品卡片图片点击埋点
  $(
    ".section-main-collection-v2 .product-grid-container .product-card-v2 .product-img-link"
  ).click(function () {
    const $card = $(this).find(".product-img.active");
    let product_item = $card.attr("data-product-data");
    product_item = product_item.split("::");
    page_product_ga4_deal(product_item, "pic", "select_item");

    // 集合页VWO埋点
    window.VWO = window.VWO || [];
    VWO.event = VWO.event || function () {VWO.push(['event'].concat([].slice.call(arguments)))};
    VWO.event('collectionListingClick')
  });

  // 产品卡片learn more点击埋点
  $(
    ".section-main-collection-v2 .product-grid-container .product-card-v2 .product-card__buttons .learn-more"
  ).click(function () {
    const $card = $(this).closest(".product-card__buttons");
    let product_item = $card
      .find(".variant-wrapper.active .product-data-div")
      .attr("data-product-data");
    product_item = product_item.split("::");
    page_product_ga4_deal(product_item, "Learn More", "select_item");

    // 集合页VWO埋点
    window.VWO = window.VWO || [];
    VWO.event = VWO.event || function () {VWO.push(['event'].concat([].slice.call(arguments)))};
    VWO.event('collectionListingClick')
  });

  //   产品卡片加购按钮
  $(
    ".section-main-collection-v2 .product-grid-container .product-card-v2 .product-card__buttons .variant-wrapper"
  ).click(function () {
    let product_item = $(this)
      .find(".product-data-div")
      .attr("data-product-data");
    product_item = product_item.split("::");
    page_product_ga4_deal(product_item, "Add to Cart", "add_to_cart");

    // 集合页VWO埋点
    window.VWO = window.VWO || [];
    VWO.event =
      VWO.event ||
      function () {
        VWO.push(["event"].concat([].slice.call(arguments)));
      };
    VWO.event("ukCollectionAddToCart");
  });

  //   compare按钮
  $(".product-compare-panel-button-compare").click(function () {
    const compareProducts = $(
      ".product-compare-panel-products .compare-item-product "
    );
    const titles = compareProducts
      .map(function () {
        return $(this).find(".compare-item-remove").attr("data-handle");
      })
      .get();

    // 将数组拼接成 product_name:"item1+item2+item3" 格式
    const productNames = titles.join("+");
    const resultString = `${productNames}`;

    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: "ga4Event",
      event_name: "compare_products",
      event_parameters: {
        button_name: "Compare",
        product_name: resultString,
      },
    });
  });

  //   compare cancel按钮
  $(".product-compare-panel-button-cancel").click(function () {
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: "ga4Event",
      event_name: "select_content",
      event_parameters: {
        button_name: "cancel",
        content_name: "collectionpage_compare",
        content_type: "collection",
      },
    });
  });

  // 使用事件委托，将事件绑定到静态的父元素上
  $(document).on(
    "click",
    ".modal-compare-result-wrapper .product-card__buttons .variant-wrapper",
    function () {
      let product_item = $(this)
        .find(".product-data-div")
        .attr("data-product-data");
      if (product_item) {
        product_item = product_item.split("::");
        page_product_ga4_deal(product_item, "BUY NOW", "add_to_cart");
      } else {
        console.warn("未找到data-product-data属性");
      }

      // 集合页VWO埋点
      window.VWO = window.VWO || [];
      VWO.event =
        VWO.event ||
        function () {
          VWO.push(["event"].concat([].slice.call(arguments)));
        };
      VWO.event("ukCollectionAddToCart");
    }
  );

  // 同样使用事件委托绑定learnmore按钮
  $(document).on(
    "click",
    ".modal-compare-result-wrapper .product-card__buttons .learn-more",
    function () {
      const $card = $(this).closest(".product-card__buttons");
      let product_item = $card
        .find(".variant-wrapper.active .product-data-div")
        .attr("data-product-data");

      if (product_item) {
        product_item = product_item.split("::");
        page_product_ga4_deal(product_item, "Learn More", "select_item");
      } else {
        console.warn("未找到data-product-data属性");
      }

      // 集合页VWO埋点
      window.VWO = window.VWO || [];
      VWO.event =
        VWO.event ||
        function () {
          VWO.push(["event"].concat([].slice.call(arguments)));
        };
      VWO.event("buttonClick");
    }
  );
});
